import React from 'react';
import axios from 'axios';
import { AuthContext } from '../Features/Authentication/AuthContext';
import { useHistory, useLocation } from 'react-router-dom';


axios.defaults.baseURL = process.env.REACT_APP_URL_BACK;

export default function AxiosSetting() {
    const authContext = React.useContext(AuthContext);
    const history = useHistory();
    const location = useLocation();

    React.useEffect(() => {
        const requestId = axios.interceptors.request.use((config) => {
            const newConfig = { ...config };
            // Exclui a rota '/recovery-password' das configurações
            if (location.pathname === '/recovery-password') {
                return newConfig; // Não aplica as configurações
            }
            if (authContext.login) {
                const { headers } = newConfig;
                const currentToken = authContext.login.token;
                headers.Authorization = `Bearer ${currentToken}`;

            }
            return newConfig;
        }, (error) => {
            return Promise.reject(error);
        });

        const responseId = axios.interceptors.response.use((response) => {
            return response;
        }, (error) => {
            let { response = {} } = error;
            if (response.status === 401 || response.status === 403) {
                response = { ...response, data: '' };
                authContext.signout(() => history.push('/'));
            }
            return Promise.reject(response);
        });
        return () => {
            axios.interceptors.request.eject(requestId);
            axios.interceptors.response.eject(responseId);
        };
    }, [authContext.login]);

    return <></>;
}
